/** @format */

import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Icon, Header, Button, Popup, Grid } from 'semantic-ui-react';
import intl from 'react-intl-universal';
import RequestPartOptions from './RequestPartOptions/RequestPartOptions';
import RequestPartLayout from './RequestPartLayout/RequestPartLayout';
import RequestPartGallery from './RequestPartGallery/RequestPartGallery';
import './RequestPart.css';

@inject('UserStore', 'RequestsStore')
@observer
class RequestPart extends Component {
  renderContent = content => {
    if (content !== undefined && content !== null && content !== '') {
      return content;
    } else {
      return '-';
    }
  };

  renderAddOptionButton = () => {
    const { RequestsStore, partId } = this.props;
    if (RequestsStore.isActive) {
      return (
        <Button
          fluid
          size="small"
          color="green"
          onClick={() => RequestsStore.toggleOptionForm(partId, true)}
        >
          <Icon name="plus" /> {intl.get('parts.add_option')}
        </Button>
      );
    }
  };

  renderRemovePartButton = () => {
    const { RequestsStore, partId } = this.props;
    if (
      RequestsStore.requestsParams.currentRequestId !== undefined &&
      RequestsStore.requestsParams.currentRequestId !== null &&
      RequestsStore.requestsParams.currentRequestId !== ''
    ) {
      return null;
    } else {
      return (
        <Popup
          trigger={
            <Icon
              className="clickable"
              name="trash"
              color="red"
              onClick={() =>
                RequestsStore.handleReqPartRemove(
                  partId,
                  RequestsStore.requestsParams.requestId,
                )
              }
            />
          }
          content="Elimina Ricambio"
        />
      );
    }
  };

  renderEditPartButton = () => {
    const { RequestsStore, partId } = this.props;
    if (RequestsStore.isActive) {
      return (
        <Popup
          trigger={
            <Icon
              onClick={() => {
                RequestsStore.togglePartForm();
                RequestsStore.loadCurrentPart(
                  partId,
                  RequestsStore.requestsParams.requestId,
                );
              }}
              className="clickable"
              name="pencil"
            />
          }
          content="Modifica Ricambio"
        />
      );
    }
  };

  renderImage = currentReqPart => {
    if (currentReqPart.data.imgUrl || currentReqPart.data.uploadedFile) {
      return (
        <Grid>
          <Grid.Row className="reqPart-head">
            <Grid.Column computer="16">
              <img
                alt="requested part"
                src={
                  currentReqPart.data.imgUrl
                    ? currentReqPart.data.imgUrl
                    : currentReqPart.data.uploadedFile
                }
                style={{ width: '100%' }}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      );
    } else {
      return null;
    }
  };

  render() {
    const { RequestsStore, partId } = this.props;
    const currentReqPart = RequestsStore.currentRequest.reqParts[partId];
    const images =
      typeof currentReqPart.data.partGallery !== 'undefined'
        ? Object.values(currentReqPart.data.partGallery)
        : [];

    return (
      <RequestPartLayout
        image={
          images.length !== 0 ? (
            <RequestPartGallery
              removes={false}
              partId={partId}
              images={images}
            />
          ) : null
        }
        header={
          <Header as="h3">
            {this.renderContent(currentReqPart.data.part)}&nbsp;
            {this.renderContent(currentReqPart.data.carSide)}&nbsp;
            {this.renderContent(currentReqPart.data.carMaker)}&nbsp;
            {this.renderContent(currentReqPart.data.carModel)}
            <Header.Subheader>
              {this.renderContent(currentReqPart.data.carVersion)}
            </Header.Subheader>
          </Header>
        }
        removePartButton={this.renderRemovePartButton()}
        editPartButton={this.renderEditPartButton()}
        partId={partId}
        toggleOptionButton={this.renderAddOptionButton()}
        requestPartOptions={<RequestPartOptions partId={partId} />}
      />
    );
  }
}

export default RequestPart;
